export default __webpack_public_path__ + "static/media/rank-a.f1dd452d.svg";